// @ts-check
import React, { useEffect, useState } from 'react';
import { api } from '../api.js';

export default function Dashboard() {
  const [stats, setStats] = useState(/** @type {any} */ (null));
  const [err, setErr] = useState('');

  useEffect(() => {
    api('/admin/stats').then(setStats).catch((e) => setErr(e.message));
  }, []);

  if (err) return <p className="text-red-400">{err}</p>;
  if (!stats) return <p>Loading…</p>;

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">HQ Dashboard</h1>
      <div className="grid grid-cols-4 gap-4">
        <Stat label="Branches" value={stats.branches} />
        <Stat label="Users" value={stats.users} />
        <Stat label="Products" value={stats.products} />
        <Stat label="Bills" value={stats.bills} />
      </div>
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <div className="card">
      <div className="text-neutral-400 text-sm">{label}</div>
      <div className="text-3xl font-bold">{value}</div>
    </div>
  );
}
